const cardsHelpXA3 =  {
    "cardHeading": "Some of my specialities include:",
    "cardItems": [
      {
        "title": "Billing",
        "icon": "Billing",
        "intent": "skill.billing.bill"
      },
      {
        "title": "Xfinity TV support",
        "icon": "TV",
        "intent": "tv"
      },
      {
        "title": "Xfinity Voice support",
        "icon": "Voice",
        "intent": "voice"
      },
      {
        "title": "Xfinity Internet support",
        "icon": "Internet",
        "intent": "internet"
      },
      {
        "title": "Xfinity Home Security",
        "icon": "Home",
        "intent": "home"
      },
      {
        "title": "Forgot username or password",
        "icon": "ForgotUserNamePassword",
        "intent": "login_and_password"
      },
      {
        "title": "Xfinity app support",
        "icon": "AppSupport",
        "intent": "apps"
      },
      {
        "title": "Xfinity Mobile support",
        "icon": "XfinityMobile",
        "intent": "mobile"
      },
      {
        "title": "TV remote pairing",
        "icon": "RemotePairing",
        "intent": "tv-remote"
      }
    ]
  }

export default cardsHelpXA3;